<template>
  <eg-modal
    id="new-folder-modal"
    :title="$t('common.newFolder', { entity: titleEntity })"
    size="md"
    centered
    class="new-folder-modal"
  >
    <template #modal-footer="{ close }">
      <div class="d-flex align-items-center justify-content-end">
        <eg-button type="secondary" @click="close">{{
          $t("common.back")
        }}</eg-button>
        <eg-button
          class="ml-2"
          :disabled="folderName.length === 0 || loading"
          type="primary"
          :is-loading="loading"
          :loading-text="$t('common.creating')"
          @click="createFolder"
        >
          {{ $t("common.createFolder", { entity: titleEntity }) }}
        </eg-button>
      </div>
    </template>

    <div>
      <eg-b-form-group
        :label="$t('common.folderEntityName', { entity: titleEntity })"
        label-for="new-folder-name"
      >
        <eg-b-form-input
          id="new-folder-name"
          v-model="folderName"
          autofocus
          :placeholder="$t('common.folderNamePlaceholder')"
          type="text"
          @keyup.enter="createFolder"
        ></eg-b-form-input>
      </eg-b-form-group>
    </div>
  </eg-modal>
</template>

<script>
import EgButton from "@/components/global/eg/buttons/eg_button.vue";
import { addFolder } from "@/api";

export default {
  name: "NewFolderModal",

  components: {
    EgButton,
  },

  inject: ["workspacesProvider"],

  props: {
    folderId: {
      type: Number,
      default: null,
    },
    workspaceKey: {
      type: String,
      required: true,
    },
    isFolder: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      folderName: "",
      loading: false,
    };
  },

  computed: {
    isRoot() {
      return this.folderId === null || this.folderId === undefined;
    },

    titleEntity() {
      return this.isFolder
        ? this.$t("common.class")
        : this.$t("common.assignment");
    },
  },

  methods: {
    async createFolder() {
      if (this.folderName.length === 0) {
        this.$showToastError(
          this.$t("common.folderEntityNameEmpty", { entity: this.titleEntity })
        );
        return;
      }

      this.loading = true;

      try {
        const response = await addFolder({
          folders: [
            {
              name: this.folderName,
              parentId: this.isRoot ? null : +this.folderId,
            },
          ],
        });

        if (!response.data || response.data.length === 0) return;

        const newFolder = response.data[0];

        if (!this.isFolder) {
          newFolder.isAssignment = true;
          newFolder.hasGradingDetails = 0;
        }

        this.workspacesProvider.addFolderWhere(
          this.workspaceKey,
          (node) => +node.id === +newFolder.parentId,
          newFolder
        );

        this.$egModal.hide("new-folder-modal");
        this.$router.push({
          name: this.isFolder ? "workspace" : "workspace-essay-upload",
          params: {
            workspaceKey: this.workspaceKey,
            id: newFolder.id,
          },
        });
        this.$showToastSuccess(
          this.$t("common.folderCreated", { entity: this.titleEntity }),
          {
            title: this.$t("common.success"),
          }
        );
      } catch (error) {
        this.$showToastError(
          error?.response?.data?.error ||
            this.$t("common.folderCreateFailed", {
              entity: this.titleEntity.toLowerCase(),
            })
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
